import React, { useState, useEffect, useRef } from "react";
import './App.css';
import { auth, db } from './Firebase';
import { collection, doc, setDoc, where, addDoc, getDocs, getDoc, query, orderBy, startAfter, limit, updateDoc, listCollections, collectionGroup } from 'firebase/firestore';
import { FaPlay, FaReadme, FaArrowLeft, FaSignOutAlt, FaSpinner, FaCloudDownloadAlt, FaEdit, FaMarkdown, FaEnvelopeOpenText, FaHeadphones, FaYoutube, FaPrint, FaChevronDown, FaChevronUp, FaGraduationCap } from 'react-icons/fa';
import HomeWorkComponent from "./HomeWorkComponent";
import ExplainComponent from "./ExplainComponent";

let generatedDocID = '';
let autoPromptSeparator = '### all the text from below is strictly for reference and prompt purpose to answer the question asked above this line. ######### '
let homeWorkInput = '';
let simpleQuestionsPrompt = '';
let difficultQuestionsPrompt = '';
let explainInput = '';
let explainPrompt = '';
let quickExplainPrompt = 'Please explain the topic in simple and plain english language with relevant words or vocabulary specific to the topic. Provide a summary at the end. Please include one real life example and one analogy to make it more relatable';
let modelHomeWork = 'gemini-fast';
let modelExplain = 'gemini';
let modelQuickExplain = 'gemini-fast';
let sourceData = '';
let modelDifficutlHomeWork = 'gemini';
let modelExplainAdmin = 'claude';
let modelDifficutlHomeWorkAdmin = 'claude';
let newWindowParameter = 'h';
function App({ user, grade, subject, source }) {
  const [selectedGrade, setSelectedGrade] = useState(grade);
  const [invocationType, setInvocationType] = useState('');
  const [selectedSubject, setSelectedSubject] = useState(subject);
  const [generatedContent, setGeneratedContent] = useState('');
  const [topicExplanation, setTopicExplanation] = useState('');
  const [uid, setUid] = useState(user.uid);
  const [isGeneratingGeminiSearch, setIsGeneratingGeminiSearch] = useState(false);
  const [temperature, setTemperature] = useState(0.7);
  const temperatureRef = useRef(temperature);
  const [top_p, setTop_p] = useState(0.8);
  const top_pRef = useRef(top_p);
  const [ishomeWork, setIshomeWork] = useState([]);
  const [isDifficulthomeWork, setIsDifficulthomeWork] = useState([]);
  const [isExplain, setIsExplain] = useState([]);
  const [isQuickExplain, setIsQuickExplain] = useState([]);
  const [isQuickExplainCompleted, SetIsQuickExplainCompleted] = useState([]);
  const [isExplainInDetailCompleted, setIsExplainInDetailCompleted] = useState([]);
  const [isSimpleQuestionsCompleted, setIsSimpleQuestionsCompleted] = useState([]);
  const [isDifficultQuestionsCompleted, setIsDifficultQuestionsCompleted] = useState([]);
  const [currentDocId, setCurrentDocId] = useState([]);
  const [showHomeWorkComponent, setShowHomeWorkComponent] = useState(false);
  const [showExplainComponent, setShowExplainComponent] = useState(false);
  const [availableGrades, setAvailableGrades] = useState([]);
  const [balance, setBalance] = useState(0);
  const [lowBalance, setLowBalance] = useState(false);
  const [expandedGrade, setExpandedGrade] = useState(null);
  const lowBalanceAmount = 2;
  const [showHomeWork, setShowHomeWork] = useState(false);
  const [showExplain, setShowExplain] = useState(false);
  useEffect(() => {
    const initializeApp = async () => {
      sourceData = 'schoolGradesData';
      if (source) {
        sourceData = source;
        console.log('Source from app parameter:', source);
      }
      const params = new URLSearchParams(window.location.search);
      if (params.get('source')) {
        sourceData = params.get('source');
        console.log('Source from URL parameter:', sourceData);
      }
      // Check if the specific sub-collection document exists, if not create it
      const myGenaiDocRef = doc(db, 'genai', user.uid);
      const myGenaiDocSnap = await getDoc(myGenaiDocRef);
      if (!myGenaiDocSnap.exists()) {
        setBalance(2);
        try {
          await setDoc(myGenaiDocRef, { balance: 2, source: 'genai-tutor.com', created_at: new Date(), modified_at: new Date() });
          console.log('MyGenAI document created with initial balance.');
        } catch (error) {
          console.error('Error creating MyGenAI document:', error);
        }
      }
      if (myGenaiDocSnap.exists()) {
        const userData = myGenaiDocSnap.data();
        const userBalance = userData.balance || 0;
        setBalance(userBalance);
        console.log('User balance:', userBalance);
        if (userBalance <= lowBalanceAmount) {
          setLowBalance(true);
        }
      }
      await fetchGradesAndSubjects();
      await fetchTexts();
      if (source === 'Explain' || source === 'HomeWork') {
        console.log('Source from app parameter:', source);
        console.log('Grade:', grade, ' Subject:', subject);
        await updateStatusOfTopics(grade, subject);
      }
    };
    initializeApp();
  }, []);



  const fetchGradesAndSubjects = async () => {
    try {
      const learnCollectionRef = collection(db, 'learn');
      const gradeDocsSnapshot = await getDocs(learnCollectionRef);
      const gradesDataPromises = gradeDocsSnapshot.docs.map(async (gradeDoc) => {
        const gradeName = gradeDoc.id;
        const gradeData = gradeDoc.data();
        const gradeSequence = gradeData.grade_sequence || 0;
        const subjectsCollectionRef = collection(db, 'learn', gradeName, 'subjects');
        const subjectDocsSnapshot = await getDocs(subjectsCollectionRef);
        const subjects = subjectDocsSnapshot.docs.map(subjectDoc => {
          const subjectData = subjectDoc.data();
          const subjectName = subjectDoc.id.replace(/_-_/g, ' - ');
          const subjectSequence = subjectData.subject_sequence || 0;
          return { id: subjectDoc.id, name: subjectName, sequence: subjectSequence };
        });

        subjects.sort((a, b) => a.sequence - b.sequence);

        return { id: gradeName, sequence: gradeSequence, subjects: subjects };
      });

      let grades = await Promise.all(gradesDataPromises);

      grades.sort((a, b) => a.sequence - b.sequence);

      setAvailableGrades(grades);
      console.log('Fetched and Sorted Grades and Subjects:', grades);
    } catch (error) {
      console.error("Error fetching grades and subjects: ", error);
    }
  };

  const handleSignOut = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const fetchTexts = async () => {
    let q;
    try {
      console.log('Fetching Texts from user collection');
      q = query(collection(db, 'genai', 'bTGBBpeYPmPJonItYpUOCYhdIlr1', 'prompts'), where('tag', '>', ''),
        where('fullText', '>', ''), orderBy('modifiedDateTime', 'asc'));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        switch (data.tag) {
          case 'autoPromptSeparator':
            autoPromptSeparator = data.fullText;
            break;
          case 'explain_quickly':
            quickExplainPrompt = data.fullText;
            console.log('quickExplainPrompt:', quickExplainPrompt);
            break;
          case 'practice_questions':
            simpleQuestionsPrompt = data.fullText;
            console.log('simpleQuestionsPrompt:', simpleQuestionsPrompt);
            break;
          case 'difficult_questions':
            difficultQuestionsPrompt = data.fullText;
            console.log('difficultQuestionsPrompt:', difficultQuestionsPrompt);
            break;
          case 'explain':
            explainPrompt = data.fullText;
            console.log('explainPrompt:', explainPrompt);
            break;
          default:
            break;
        }
      });
      const configurationCollection = collection(db, 'public');
      q = query(configurationCollection, where('setup', '==', 'genaiAdmin'));
      const configurationSnapshot = await getDocs(q);
      configurationSnapshot.forEach(doc => {
        const data = doc.data();
        if (data.modelHomeWork !== undefined) {
          modelHomeWork = data.modelHomeWork;
        }
        if (data.modelExplain !== undefined) {
          modelExplain = data.modelExplain;
        }
        if (data.modelDifficutlHomeWork !== undefined) {
          modelDifficutlHomeWork = data.modelDifficutlHomeWork;
        }
        if (data.modelExplainAdmin !== undefined) {
          modelExplainAdmin = data.modelExplainAdmin;
        }
        if (data.modelDifficutlHomeWorkAdmin !== undefined) {
          modelDifficutlHomeWorkAdmin = data.modelDifficutlHomeWorkAdmin;
        }
        if (data.modelQuickExplain !== undefined) {
          modelQuickExplain = data.modelQuickExplain;
        }
      });
    } catch (error) {
      console.error("Error fetching texts: ", error);
    }
  };

  const callAPI = async (modelName, promptText, invocationType = 'simple_questions', education_reference) => {
    console.log(' modelName ' + modelName + '   ****** Calling API with URL: ' + process.env.REACT_APP_GENAI_API_URL, ' invocationType: ', invocationType, '  promptText:', promptText);
    try {
      let response;
      console.log('temp:', temperatureRef.current.valueOf(), 'top_p:', top_pRef.current.valueOf());
      console.log('promptText:', promptText);
      console.log('invocationType:', invocationType);
      console.log('uid:', uid);
      console.log('create new document');
      response = await fetch(process.env.REACT_APP_GENAI_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          prompt: promptText,
          model: modelName,
          uid: uid,
          temperature: temperatureRef.current.valueOf(),
          top_p: top_pRef.current.valueOf(),
          invocationType: invocationType,
          education_reference: education_reference
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error + 'Failed to generate content');
        throw new Error(errorData.error || 'Failed to generate content.');
      }

      let data;
      data = await response.json();
      generatedDocID = data[0].results[0].docID;
      console.log('Generated Doc ID:', generatedDocID, '  invocationType:', invocationType);
      setInvocationType(invocationType);
      setCurrentDocId(generatedDocID);

      /*if (invocationType === 'explain_quickly' || invocationType === 'explain_in_detail') { 
        setShowExplainComponent(true);
        return;
      }
      else {
        setShowHomeWorkComponent(true);
        return
      }*/
      if (invocationType === 'explain_quickly' || invocationType === 'explain_in_detail') {
        newWindowParameter = 'e';
      }
      else {
        newWindowParameter = 'h';
      }
      window.open(`/?${newWindowParameter}=${generatedDocID}`, '_blank');
      return;
    } catch (error) {
      console.error('Error generating content:', error);
      console.log(`Error: ${error.message}`);
    } finally {
      invocationType = '';
      console.log('Fetching data after generating content');
      console.log('isGeneratingGeminiSearch:', isGeneratingGeminiSearch);
    }
  };

  const updateStatusOfTopics = async (grade, subject) => {
    console.log('updateStatusOfTopics called with grade:', grade, 'subject:', subject);
    const subjectDocId = subject.replace(/ - /g, '_-_');
    const topicsCollectionRef = collection(db, 'learn', grade, 'subjects', subjectDocId, 'topics');
    const topicsSnapshot = await getDocs(query(topicsCollectionRef));
    let fetchedTopics = topicsSnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        name: data.topic,
        sequence: data.sequence || 0
      };
    });
    fetchedTopics.forEach(async (topic) => {
      //  console.log('Topics doc id', topic.id, ' name:', topic.name, ' sequence:', topic.sequence);
      const education_reference = topic.id;
      const dbCollection = collection(db, 'genai', user.uid, 'MyGenAI');
      const dbQuickExplainquery = query(dbCollection, where('education_reference', '==', education_reference), where('invocationType', '==', 'explain_quickly'));
      const docQuickExplainSnap = await getDocs(dbQuickExplainquery);
      if (docQuickExplainSnap.docs.length > 0) {
        //  console.log('Document exists, fetching data for doc id', topic.id, ' name:', topic.name, ' sequence:', topic.sequence);
        SetIsQuickExplainCompleted(prev => ({ ...prev, [education_reference]: true }));
      }
      else {
        //  console.log('Document does not exist');
        SetIsQuickExplainCompleted(prev => ({ ...prev, [education_reference]: false }));
      }

      const dbExplainInDetailquery = query(dbCollection, where('education_reference', '==', education_reference), where('invocationType', '==', 'explain_in_detail'));
      const docExplainInDetailSnap = await getDocs(dbExplainInDetailquery);
      if (docExplainInDetailSnap.docs.length > 0) {
        //   console.log('Document exists, fetching data for doc id', topic.id, ' name:', topic.name, ' sequence:', topic.sequence);
        setIsExplainInDetailCompleted(prev => ({ ...prev, [education_reference]: true }));
      }
      else {
        console.log('Document does not exist');
        setIsExplainInDetailCompleted(prev => ({ ...prev, [education_reference]: false }));
      }
      const dbSimpleQuestionsquery = query(dbCollection, where('education_reference', '==', education_reference), where('invocationType', '==', 'simple_questions'));
      const docSimpleQuestionsSnap = await getDocs(dbSimpleQuestionsquery);
      if (docSimpleQuestionsSnap.docs.length > 0) {
        //  console.log('Document exists, fetching data for doc id', topic.id, ' name:', topic.name, ' sequence:', topic.sequence);
        setIsSimpleQuestionsCompleted(prev => ({ ...prev, [education_reference]: true }));
      }
      else {
        //  console.log('Document does not exist');
        setIsSimpleQuestionsCompleted(prev => ({ ...prev, [education_reference]: false }));
      }
      const dbDifficultQuestionsquery = query(dbCollection, where('education_reference', '==', education_reference), where('invocationType', '==', 'difficult_questions'));
      const docDifficultQuestionsSnap = await getDocs(dbDifficultQuestionsquery);
      if (docDifficultQuestionsSnap.docs.length > 0) {
        //  console.log('Document exists, fetching data for doc id', topic.id, ' name:', topic.name, ' sequence:', topic.sequence);
        setIsDifficultQuestionsCompleted(prev => ({ ...prev, [education_reference]: true }));
      }
      else {
        //    console.log('Document does not exist');
        setIsDifficultQuestionsCompleted(prev => ({ ...prev, [education_reference]: false }));
      }
    });
  };

  const GradeBox = ({ gradeObj }) => {
    const isExpanded = expandedGrade === gradeObj.id;

    const toggleGradeExpansion = () => {
      if (isExpanded) {
        setExpandedGrade(null);
      } else {
        setExpandedGrade(gradeObj.id);
      }
    };

    return (
      <div className={`grade-box ${isExpanded ? 'expanded' : ''}`} onClick={isExpanded ? null : toggleGradeExpansion}>
        <div className="grade-header">
          <div className="grade-icon">
            <FaGraduationCap />
          </div>
          <h3>{gradeObj.id}</h3>
          <button
            className="expand-button"
            onClick={(e) => {
              e.stopPropagation();
              toggleGradeExpansion();
            }}
          >
            {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </button>
        </div>

        {isExpanded && (
          <div className="subjects-container">
            {gradeObj.subjects.map(subject => (
              <button
                key={subject.id}
                className="subject-button"
                onClick={async (e) => {
                  e.stopPropagation();
                  setSelectedGrade(gradeObj.id);
                  setSelectedSubject(subject.name);
                  updateStatusOfTopics(gradeObj.id, subject.name);
                }}
              >
                {subject.name}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  const SubjectContent = ({ grade, subject }) => {
    const [topics, setTopics] = useState([]);
    const [isLoadingTopics, setIsLoadingTopics] = useState(false);

    const fetchTopics = async () => {
      if (!grade || !subject) return;
      setIsLoadingTopics(true);
      try {
        const subjectDocId = subject.replace(/ - /g, '_-_');
        const topicsCollectionRef = collection(db, 'learn', grade, 'subjects', subjectDocId, 'topics');
        const topicsSnapshot = await getDocs(query(topicsCollectionRef));
        let fetchedTopics = topicsSnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            name: data.topic,
            sequence: data.sequence || 0
          };
        });
        fetchedTopics.sort((a, b) => a.sequence - b.sequence);
        setTopics(fetchedTopics);
        console.log(`Fetched and sorted topics for ${grade} - ${subject}:`, fetchedTopics);
      } catch (error) {
        console.error("Error fetching topics: ", error);
        setTopics([]);
      } finally {
        setIsLoadingTopics(false);
      }
    };

    useEffect(() => {
      fetchTopics();
    }, [grade, subject]);

    if (!grade || !subject) {
      return <div>Loading...</div>;
    }
    return (
      <div className="subject-content">
        <button className="subject-button"
          onClick={() => {
            setSelectedGrade(null);
            setSelectedSubject(null);
            setGeneratedContent('');
            setTopicExplanation('');
            setTopics([]);
          }}
        >
          Previous Page
        </button>
        &nbsp;
        &nbsp;
        <button
          className="genai-button"
          onClick={() => window.open('https://genai-all.com', '_blank')}
        >
          GenAI Hub
        </button>

        &nbsp;&nbsp;&nbsp;
        <span style={{ margin: '10px 0', fontWeight: 'bold', color: 'darkslateblue' }}>
          Balance : ${balance.toFixed(2)}
        </span>
        &nbsp;&nbsp;&nbsp;
        <span className="info-text" style={{
          fontSize: '14px',
          color: '#666',
          marginTop: '5px',
        }}>
          Please allow pop-up windows in your browser to see explanation/questions. To reload the balance, click on "GenAI Hub" button and login. <br />
        </span>
        <h2> <span style={{ color: 'darkBlue' }}>{grade}</span> - <span style={{ color: 'darkGreen' }}>{subject}</span></h2>
        <div className="topics-container">
          {isLoadingTopics ? (
            <FaSpinner className="spinning" />
          ) : topics.length === 0 ? (
            <p>No topics found for this subject.</p>
          ) : (
            topics.map((topic) => (
              <div key={topic.id} className="topic-item">
                <span>{topic.name}</span>
                &nbsp;&nbsp;
                <button
                  className={isQuickExplainCompleted[topic.id] ? "button_completed" : "button_pending"}
                  onClick={async (e) => {
                    // prevent the page from scrolling to the top
                    e.preventDefault();
                    // get sticky scroll position
                    const scrollPosition = window.scrollY;
                    console.log('scrollPosition:', scrollPosition);
                    // stay at the same scroll position
                    setIsQuickExplain(prev => ({ ...prev, [topic.id]: true }));
                    setTemperature(0.7);
                    setTop_p(0.8);
                    await new Promise(resolve => setTimeout(resolve, 200));
                    explainInput = grade + ' : ' + subject + ' : ' + topic.name + quickExplainPrompt;
                    console.log('explainInput:', explainInput);
                    window.scrollTo(0, scrollPosition);
                    await callAPI(modelQuickExplain, explainInput, 'explain_quickly', topic.id);
                    setIsQuickExplain(prev => ({ ...prev, [topic.id]: false }));
                  }}
                >
                  {isQuickExplain[topic.id]
                    ? (<FaSpinner className="spinning" />)
                    : 'Explain Quickly'}
                </button>
                <button
                  className={isExplainInDetailCompleted[topic.id] ? "button_completed" : "button_pending"}
                  onClick={async (e) => {
                    // prevent the page from scrolling to the top
                    e.preventDefault();
                    // get sticky scroll position
                    const scrollPosition = window.scrollY;
                    setIsExplain(prev => ({ ...prev, [topic.id]: true }));
                    setTemperature(0.8);
                    setTop_p(0.8);
                    await new Promise(resolve => setTimeout(resolve, 500));
                    explainInput = grade + ' : ' + subject + ' : ' + topic.name + explainPrompt;
                    console.log('explainInput:', explainInput);
                    if (['sharathck@outlook.com'].includes(user.email)) {
                      modelExplain = modelExplainAdmin;
                    }
                    window.scrollTo(0, scrollPosition);
                    await callAPI(modelExplain, explainInput, 'explain_in_detail', topic.id);
                    setIsExplain(prev => ({ ...prev, [topic.id]: false }));
                  }}
                  disabled={isExplain[topic.id]}
                >
                  {isExplain[topic.id]
                    ? (<FaSpinner className="spinning" />)
                    : 'Explain in Detail'}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  className={isSimpleQuestionsCompleted[topic.id] ? "button_completed" : "button_pending"}
                  onClick={async (e) => {
                    // prevent the page from scrolling to the top
                    e.preventDefault();
                    // get sticky scroll position
                    const scrollPosition = window.scrollY;
                    setIshomeWork(prev => ({ ...prev, [`simple-${topic.id}`]: true }));
                    homeWorkInput = grade + ' : ' + subject + ' : ' + topic.name + autoPromptSeparator + ' ' + simpleQuestionsPrompt;
                    setTemperature(0.2);
                    setTop_p(0.3);
                    window.scrollTo(0, scrollPosition); await new Promise(resolve => setTimeout(resolve, 1000));
                    console.log('homeWorkInput (Simple): ', homeWorkInput);
                    await callAPI(modelHomeWork, homeWorkInput, 'simple_questions', topic.id);
                    setIshomeWork(prev => ({ ...prev, [`simple-${topic.id}`]: false }));
                  }}
                  disabled={ishomeWork[`simple-${topic.id}`]}
                >
                  {ishomeWork[`simple-${topic.id}`]
                    ? (<FaSpinner className="spinning" />)
                    : 'Easy Questions'}
                </button>
                <button
                  className={isDifficultQuestionsCompleted[topic.id] ? "button_completed" : "button_pending"}
                  onClick={async (e) => {
                    // prevent the page from scrolling to the top
                    e.preventDefault();
                    // get sticky scroll position
                    const scrollPosition = window.scrollY;
                    setIsDifficulthomeWork(prev => ({ ...prev, [`difficult-${topic.id}`]: true }));
                    homeWorkInput = grade + ' : ' + subject + ' : ' + topic.name + autoPromptSeparator + ' ' + difficultQuestionsPrompt;
                    setTemperature(0.4);
                    setTop_p(0.4);
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    console.log('homeWorkInput (Difficult): ', homeWorkInput);
                    if (['sharathck@outlook.com'].includes(user.email)) {
                      modelDifficutlHomeWork = modelDifficutlHomeWorkAdmin;
                    }
                    window.scrollTo(0, scrollPosition); await callAPI(modelDifficutlHomeWork, homeWorkInput, 'difficult_questions', topic.id);
                    setIsDifficulthomeWork(prev => ({ ...prev, [`difficult-${topic.id}`]: false }));
                  }}
                  disabled={isDifficulthomeWork[`difficult-${topic.id}`]}
                >
                  {isDifficulthomeWork[`difficult-${topic.id}`]
                    ? (<FaSpinner className="spinning" />)
                    : 'Questions'}
                </button>
                <br />
              </div>
            ))
          )}
        </div>
      </div>
    );
  };


  return (
    <div className="App">
      {showHomeWorkComponent && (
        <HomeWorkComponent
          sourceDocumentID={generatedDocID}
          grade={selectedGrade}
          subject={selectedSubject}
        />
      )}
      {showExplainComponent && (
        <ExplainComponent
          sourceDocumentID={generatedDocID}
          grade={selectedGrade}
          subject={selectedSubject}
        />
      )}
      {!showHomeWorkComponent && !showExplainComponent && selectedSubject && (
        <SubjectContent grade={selectedGrade} subject={selectedSubject} />
      )}
      {!selectedSubject && !showHomeWorkComponent && !showExplainComponent && (
        <div>
          <button
            className="genai-button"
            onClick={() => window.open('https://genai-all.com', '_blank')}
          >
            GenAI Hub
          </button>
          &nbsp;&nbsp;&nbsp;
          <span style={{ margin: '10px 0', fontWeight: 'bold', color: 'darkslateblue' }}>
            Balance : ${balance.toFixed(2)}
          </span>
          &nbsp;&nbsp;&nbsp;
          <button className="signoutbutton" onClick={handleSignOut}>
            <FaSignOutAlt />
          </button>
          <span style={{ margin: '10px 0', color: 'darkslateblue' }}>
            {user.email}
          </span>
          <div className="grades-container">
            {availableGrades.length > 0 ? (
              availableGrades.map(gradeObj => (
                <GradeBox key={gradeObj.id} gradeObj={gradeObj} />
              ))
            ) : (
              <p>Loading grades...</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
